import { ReactElement, useState } from "react";
import { Box } from "@twilio-paste/core/box";
import { DownloadIcon } from "@twilio-paste/icons/esm/DownloadIcon";
import {
  ChatAttachment,
  ChatAttachmentLink,
  ChatBubble,
  ChatMessage,
} from "@twilio-paste/core/chat-log";

import ImagePreviewModal from "../imagePreviewModal";
import { types } from "../../definitions";
import {
  AttachmentUtils,
  truncate,
} from "@twiliointernal/e2-commons-shared-utils";

const ChatFilePreview = ({
  attachment,
  variant,
}: types.ChatAttachmentPreviewProps): ReactElement => {
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);

  const openImagePreview = (): void => {
    setIsImagePreviewOpen(true);
  };

  const closeImagePreview = (): void => {
    setIsImagePreviewOpen(false);
  };

  const renderImageAttachment = (): ReactElement => (
    <Box
      display="flex"
      justifyContent="center"
      padding="space30"
      height="size10"
      cursor="point"
      onClick={openImagePreview}
    >
      <img
        src={attachment.url}
        alt={attachment.name}
        style={{ minWidth: "100%", minHeight: "100%", objectFit: "contain" }}
        title={attachment.name}
      />

      <ImagePreviewModal
        onDismiss={closeImagePreview}
        isOpen={isImagePreviewOpen}
        image={attachment}
      />
    </Box>
  );

  const isImage = AttachmentUtils.isImage(attachment.name, attachment.type);
  const attachmentIcon = isImage ? (
    renderImageAttachment()
  ) : (
    <DownloadIcon color="colorText" decorative />
  );

  return (
    <ChatMessage variant={variant}>
      <ChatBubble>
        <ChatAttachment attachmentIcon={attachmentIcon}>
          <ChatAttachmentLink href={attachment.url}>
            {truncate(attachment.name, 10, 5)}
          </ChatAttachmentLink>
        </ChatAttachment>
      </ChatBubble>
    </ChatMessage>
  );
};

export default ChatFilePreview;
